import { schema } from 'normalizr';

const domain = new schema.Entity( 'domains', {}, {
    idAttribute: 'domainName',
} );

export const suggestedDomainsSchema = [ domain ];
